// extracted by mini-css-extract-plugin
export default {"mobileBreakpoint":"767","tabletBreakpoint":"999","verticalOrientedBreakpoint":"1319","section":"styles-module--section--9NcjH","map":"styles-module--map--qI1z4"};